import styled from 'styled-components';

export const venue = styled.p`
    font-size: var(--font-size-body-small);
    line-height: 1.2;
    text-align: center;
    color: var(--primitive-gray-600);
`;

export const name = styled.span`
    font-weight: var(--font-weight-bold);
`;
